export default __webpack_public_path__ + "static/media/demand.1f7010b7.svg";